import { Icons } from '@/assets/icons/icons';
import { Button, XStack } from '@/components/ui';
import { handleExternalUrlClick } from '@/utils/platform';

const TARGETS = [
  {
    icon: Icons.reddit,
    label: 'Reddit',
    base: 'https://www.reddit.com/submit',
  },
  { icon: Icons.twitter, label: 'X', base: 'https://x.com/intent/post' },
  {
    icon: Icons.linkedin,
    label: 'LinkedIn',
    base: 'https://www.linkedin.com/shareArticle',
  },
] as const;

export const ShareSocialButtons = ({ url }: { url: string }) => (
  <XStack className="gap-1 items-center">
    {TARGETS.map(({ icon: Icon, label, base }) => (
      <Button
        key={base}
        size="icon-sm"
        variant="ghost"
        aria-label={`Share on ${label}`}
        onClick={() => {
          const shareUrl = new URL(base);
          shareUrl.searchParams.set('url', url);
          handleExternalUrlClick(shareUrl.toString());
        }}
      >
        <Icon />
      </Button>
    ))}
  </XStack>
);
